<template>
  <Reference
    :id="managerId"
    :value="value"
    :total-items="totalItems"
    :label="label"
    :items.sync="items"
    component-name="Manager"
    placeholder="Введіть iм'я менeджера"
    data-test="manager-select"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as managersApi from "@/backend/managersApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Менеджер",
    },
    value: {
      type: Object,
    }
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  computed: {
    managerId() {
      return this.value?.id || null;
    },
  },
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await managersApi.selectManager(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
